export const INDUSTRIES = [
  {
    slug: "steel",
    index: "01",
    name: "Steel",
    short: "Rolls for pickling, galvanising, coating and processing lines across the steel industry.",
    images: ["/images/steel_01.jpg", "/images/steel_02.jpg"],
    intro:
      "Steel processing lines put rolls under continuous load, heat and chemical exposure. Vikas Rolls covers and manufactures rolls for positions across pickling, galvanising, coating and strip-processing lines.",
    groups: [
      { title: "Strip Control & Tension", rolls: ["Bridle Rolls", "Steering Rolls", "Guidance Rolls", "Deflector Rolls", "Accumulator Rolls", "Stabilizer Rolls"] },
      { title: "Nip & Squeeze", rolls: ["Squeeze Rolls", "Pinch Rolls", "Wringer Rolls", "Hold-Down Rolls", "Snubber Rolls"] },
      { title: "Coating & Application", rolls: ["Applicator Rolls", "Pick-Up Rolls", "Dipping Rolls"] },
      { title: "Support & Handling", rolls: ["Leveller Rolls", "Support Rolls", "Sink Rolls", "Table Rolls"] },
    ],
  },
  {
    slug: "paper",
    index: "02",
    name: "Paper",
    short: "Rolls for every section of the paper machine — wire to Yankee.",
    images: ["/images/paper_01.jpg", "/images/paper_02.jpg"],
    intro:
      "From the wire section to finishing, each position on a paper machine demands a different balance of hardness, release and durability. Vikas Rolls supplies and refurbishes rolls across the full machine.",
    groups: [
      { title: "Wire Section", rolls: ["Table Rolls", "Breast Rolls", "Guide Rolls", "Return Rolls", "Tension Rolls", "Drive Rolls", "Suction Couch Rolls", "Lumpbreaker Rolls"] },
      { title: "Wet Press Section", rolls: ["Suction Press & Pick-Up Rolls", "Top Press Hard Rolls", "Blind Drilled Press Rolls", "Grooved Press Rolls", "Felt Guide Rolls", "Paper Carrying Rolls"] },
      { title: "Dryer Section", rolls: ["Felt Guide Rolls", "Size Press Hard & Soft Rolls", "Soft Breaker Stack", "Hard Breaker Stack"] },
      { title: "Coating", rolls: ["Backing Rolls", "Film-Coater Rolls", "Applicator Rolls"] },
      { title: "Finishing", rolls: ["Soft Nip Calender Rolls", "Reel Spools", "Supercalender Rolls"] },
      { title: "Yankee Section", rolls: ["Suction Pressure Rolls", "Blind Drilled Pressure Rolls", "Plain Pressure Rolls"] },
    ],
  },
  {
    slug: "packaging",
    index: "03",
    name: "Packaging",
    short: "Rolls for blown film extrusion, flexography and rotogravure printing.",
    images: ["/images/packaging_01.jpg", "/images/packaging_02.jpg"],
    intro:
      "Film and flexible-packaging lines depend on consistent nip pressure and clean web handling. Vikas Rolls supplies covered rolls for extrusion, treatment, lamination and printing positions.",
    groups: [
      { title: "Blown Film Extrusion", rolls: ["Nip Rolls (Pulling / Stretching)", "Corona Treatment Rolls", "Lamination Rolls", "Winder Rolls"] },
      { title: "Flexography / Rotogravure", rolls: ["Impression Rolls", "Ink Fountain Rolls", "Pressure Rolls"] },
    ],
  },
  {
    slug: "leather",
    index: "04",
    name: "Leather",
    short: "Machine rolls for tanneries — setting-out, samming, buffing and more.",
    images: ["/images/leather_01.jpg", "/images/leather_02.jpg"],
    intro:
      "Tannery machinery relies on rolls with the right surface character for each stage of hide processing. Vikas Rolls covers rolls for the principal leather-working machines.",
    groups: [
      { title: "Tannery Machine Rolls", rolls: ["Setting-Out Machine Rolls", "Samming Machine Rolls", "Buffing Machine Rolls", "Splitting Machine Rolls", "Fleshing Machine Rolls", "Shaving Machine Rolls"] },
    ],
  },
  {
    slug: "glass",
    index: "05",
    name: "Glass",
    short: "Heat-resistant and handling rolls for glass processing lines.",
    images: ["/images/glass_01.jpg", "/images/glass_02.jpg"],
    intro:
      "Glass handling demands rolls that combine heat resistance with surfaces gentle enough to protect the product. Vikas Rolls supplies rolls across annealing, washing and lamination positions.",
    groups: [
      { title: "Processing & Handling", rolls: ["Annealing Oven Rolls", "Feed Rolls", "Heat-Resistant Rolls", "Hold-Down Rolls", "Idler Rolls", "Nip Rolls", "Squeegee Rolls", "Support Rolls", "Washer Rolls", "Lamination Rolls"] },
    ],
  },
  {
    slug: "textile",
    index: "06",
    name: "Textile",
    short: "Rolls for mercerising, dyeing, bleaching and fabric finishing.",
    images: ["/images/textile_01.jpg", "/images/textile_02.jpg"],
    intro:
      "Wet-processing and finishing machines expose rolls to chemicals, moisture and continuous cycling. Vikas Rolls compounds covers that stand up to textile processing conditions.",
    groups: [
      { title: "Processing Machine Rolls", rolls: ["Mercerising Machine Rolls", "Dyeing Machine Rolls", "Bleaching Machine Rolls", "Stenter Rolls", "Mangle Rolls", "Jigger Rolls"] },
    ],
  },
  {
    slug: "wood-plywood",
    index: "07",
    name: "Plywood",
    short: "Feed, glue-spreader, sanding and coating rolls for wood and plywood processing.",
    images: ["/images/wood_01.jpg", "/images/wood_02.jpg"],
    intro:
      "Wood and plywood production combines abrasive feed duties with precise glue and coating application. Vikas Rolls supplies the full range of rolls used across these lines.",
    groups: [
      { title: "Feed & Handling", rolls: ["Feed Rolls", "Pull Rolls", "Anvil Rolls", "Band Saw Wheels", "Contact Rolls", "Grooved / Serrated Rolls"] },
      { title: "Application & Finishing", rolls: ["Applicator Rolls", "Glue Spreader Rolls", "Laminating Rolls", "Wide-Belt Sander Rolls", "Doctor Rolls", "Coating Rolls", "Non-Stick / High-Release Coating Rolls"] },
    ],
  },
  {
    slug: "rexine-synthetic-leather",
    index: "08",
    name: "Vinyl",
    short: "Embossing, coating and printing rolls for vinyl and coated-fabric production.",
    images: ["/images/rexine_01.jpg", "/images/rexine_02.jpg"],
    intro:
      "Vinyl and coated-fabric lines need rolls that transfer texture and coatings with complete consistency. Vikas Rolls covers rolls for each stage of vinyl, rexine and synthetic-leather production.",
    groups: [
      { title: "Production Rolls", rolls: ["Embossing Rolls", "Coating Rolls", "Contact Rolls", "Printing Rolls"] },
    ],
  },
  {
    slug: "food-beverage",
    index: "09",
    name: "Food & Beverage",
    short: "Special food-grade rubber roll applications.",
    images: ["/images/food_01.jpg", "/images/food_02.jpg"],
    intro:
      "Vikas Rolls compounds special food-grade rubber covers for processing and handling applications in the food and beverage industry. Compound suitability is confirmed against each customer's application requirements.",
    groups: [
      { title: "Applications", rolls: ["Special Food-Grade Rubber Rolls"] },
    ],
    note: "Regulatory compliance details are confirmed per application — contact us to discuss your requirements.",
  },
  {
    slug: "printing",
    index: "10",
    name: "Printing",
    short: "Rollers for sheet-fed offset, web offset and letterpress.",
    images: ["/images/printing_01.jpg", "/images/printing_02.jpg"],
    intro:
      "Print quality lives and dies by roller condition. Vikas Rolls manufactures and re-covers rollers for the principal printing processes.",
    groups: [
      { title: "Press Rollers", rolls: ["Sheet-Fed Offset Rolls", "Web & Newspaper Offset Rolls", "Letterpress Rolls"] },
    ],
  },
  {
    slug: "conveyor-rolls-pulleys",
    index: "11",
    name: "Conveyor Rolls & Pulleys",
    short: "Lagged pulleys and conveyor components for bulk handling.",
    images: ["/images/conveyor_01.jpg", "/images/conveyor_02.jpg"],
    intro:
      "Conveyor drive systems depend on pulley lagging for traction, belt tracking and wear life. Vikas Rolls manufactures and re-lags the full range of conveyor pulleys.",
    groups: [
      { title: "Pulleys", rolls: ["Drive, Head & Tail Pulleys", "Take-Up Pulleys", "Snub & Bend Pulleys", "Self-Cleaning Spiral-Wing & Drum Pulleys"] },
    ],
  },
];

export const getIndustry = (slug) => INDUSTRIES.find((i) => i.slug === slug);
